module.exports = __webpack_public_path__ + "img/tube-rolled-up.3b2e9155.svg";